module.exports = __webpack_public_path__ + "media/img/frontend_application/img-banner-fd15ff76ef0bf6d5be171613294f0d13.png";